import React from "react";

/**
 * Compact section header shared across the employee profile subtabs.
 * Renders a small icon tile, title + subtitle, and an optional action button.
 */
function EmployeeProfileTabHeader({
  icon: Icon,
  title,
  subtitle,
  actionLabel,
  actionIcon: ActionIcon,
  onAction,
  actionVariant = "filled",
}) {
  return (
    <div className="flex items-center justify-between gap-4 mb-6">
      <div className="flex items-center space-x-3">
        <div className="w-9 h-9 shrink-0 bg-violet-700 rounded-lg flex items-center justify-center">
          {Icon && (
            <Icon className="text-white" style={{ fontSize: "18px" }} />
          )}
        </div>
        <div>
          <h2 className="text-base font-semibold text-gray-900">{title}</h2>
          {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
        </div>
      </div>

      {actionLabel && (
        <button
          onClick={onAction}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
            actionVariant === "outline"
              ? "bg-white border border-gray-200 text-gray-700 hover:border-violet-300 hover:bg-violet-50"
              : "bg-violet-600 hover:bg-violet-700 text-white"
          }`}
        >
          {ActionIcon && <ActionIcon style={{ fontSize: "16px" }} />}
          <span>{actionLabel}</span>
        </button>
      )}
    </div>
  );
}

export default EmployeeProfileTabHeader;
